import { ROLE_IDS } from '@/auth/utils'

export default [
  {
    title: 'Management',
    komicon: 'k-cloud-connection',
    tagVariant: 'light-warning',
    allowedRoles: [ROLE_IDS.ADMIN],
    children: [
      {
        title: 'Staff',
        komicon: 'k-user-octagon',
        route: 'staff',
        resource: 'Management - Staff',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Divisi',
        komicon: 'k-layer',
        route: 'division',
        resource: 'Management - Divisi',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Posisi',
        komicon: 'k-status-up',
        route: 'position',
        resource: 'Management - Posisi',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Kantor Operasional',
        komicon: 'k-buildings',
        route: 'operational-office',
        resource: 'Management - Kantor Operasional',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Working Space',
        komicon: 'k-building-4',
        route: 'work-space',
        resource: 'Management - Working Space',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Mode Kerja',
        komicon: 'k-brifecase-timer',
        route: 'work-mode',
        resource: 'Management - Mode Kerja',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Data Lembur',
        komicon: 'k-clock-1',
        route: 'overtime-data',
        resource: 'Management - Data Lembur',
        action: 'manage',
      },
    ],
  },
]
